import React from 'react';
import Helmet from 'react-helmet';

import _ from '@ihme/common/locale';

const BrowserTitle = ({ title }) => {
    const defaultTitle = _('browser_title_home');
    return (
        <Helmet>
            <title>{title || defaultTitle}</title>
        </Helmet>
    );
};

export default BrowserTitle;
